export const capitalizeFirstLetter: (value: string) => string = (value: string): string => (
  value ? `${value[0].toUpperCase()}${value.slice(1)}` : value
);
